export const constants = {
  SANDBOX: "Sandbox",
  INSIGHT: "Insight",
  INSIGHT_EDU: "Insight Edu",
  BLUUM: "Bluum",
  CDW: "CDW",
  CDWG: "CDWG",
  DANDH: "D&H",
  SYNNEX: "TD SYNNEX",
  SYNNEX_Public: "TD SYNNEX_Public",
  SYNNEX_AUS: "SYNNEX-AUS",
  CONNECTION: "Connection",
  CONNECTION_GOV: "Connection_Gov",
  TRAFERA: "Trafera",
  VIVACITY: "Vivacity",
  PROMEVO: "Promevo",
  DEMO: "Demo",
  DEMO_EDU: "Demo Edu",
  STAGE: "Stage",
  DEFAULT: "Default",
  PRIMARY_USE_QUERY_PARAM: "primaryUseSelections",
  NEED_TO_RUN_QUERY_PARAM: "needToRunSelections",
  USE_CASE_QUERY_PARAM: "useCaseSelections",
  BRANDS_QUERY_PARAM: "brandSelections",
  LOCALE_QUERY_PARAM: "locale",
  FIRESTORE_INVENTORY_COLLECTION: "inventory",
  FIRESTORE_ADMINS_COLLECTION: "admins",
  SHARE_RESULTS_MESSAGE_TITLE: "chromeos-device-selector-results",
  CHROMEBASE: "Chromebase",
  CHROMEBOX: "Chromebox",
  CLAMSHELL: "Clamshell",
  CONVERTIBLE: "Convertible",
  TABLET: "Tablet",
  CHROMEBOOK: "Chromebook",
  CHROMEBOOKPLUS: "Chromebook Plus",
  TOUCHSCREEN: "touchscreen",
  INSTOCK: "In Stock",
  ENTERPRISE: "enterprise",
  NON_ENTERPRISE: "nonEnterprise",
  CHROME_X: "chromex",
  CHROMEBOOK_ENTERPRISE: "Chromebook Enterprise",
  CHROMEBOX_ENTERPRISE: "Chromebox Enterprise",
  CHROMEBASE_ENTERPRISE: "Chromebase Enterprise",
  EN_US_LOCALE: "en_US",
  EN_CA_LOCALE: "en_CA",
  FR_CA_LOCALE: "fr_CA",
  EN_GB_LOCALE: "en_GB",
  DE_GB_LOCALE: "de_GB",
  EN_LANGUAGE: "en",
  GB_COUNTRY: "gb",
  UK_REGION:  "uk",
  DEFAULT_SUBDOMAIN: "www",
  SIM_SUBDOMAIN: "sim",
  CENTIMETER: "cm",
  TEN_ELEVEN_SCREEN_SIZE_RANGE: [10,11.9],
  TWELVE_THIRTEEN_SCREEN_SIZE_RANGE: [12,13.9],
  FOURTEEN_FIFTEEN_SCREEN_SIZE_RANGE: [14,16],
  TEN_ELEVEN_SCREEN_SIZE_LABEL: '10-11"',
  TWELVE_THIRTEEN_SCREEN_SIZE_LABEL: '12-13"',
  FOURTEEN_FIFTEEN_SCREEN_SIZE_LABEL: '14-15"'
}
